import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_n34zp8ykn9: FaireBrandEntity = {
  token: "b_n34zp8ykn9",
  type: "brand",
  name: "Eidon Ionic Minerals",
  avatarUrl:
    "https://cdn.faire.com/fastly/60d98b8c50e24dc66e09b92a784afc0b868eb364177513e205ddd2f23a389688.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f8114cd9b13ec1a735f122fa98d0a9b261059ca637b146f8eaf25157efb250a1.png",
  logoUrl:
    "https://cdn.faire.com/fastly/60d98b8c50e24dc66e09b92a784afc0b868eb364177513e205ddd2f23a389688.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f8114cd9b13ec1a735f122fa98d0a9b261059ca637b146f8eaf25157efb250a1.png",
  location: "Poway, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 33,
  isInsider: true,
  description:
    "Founded in 1996, Eidon® Ionic Minerals is dedicated to quality and commitment towards educating the public about the true functions, requirements, and benefits of minerals.\n\nEidon provides its clients with a revolutionary, 99% bioavailable line of liquid mineral supplements, as well as other supporting nutrients! To be an optimally functioning organism, a complete balance of adequate mineral levels is required. Everything begins and ends on a cellular level; therefore, the lack of specific minerals can precipitate both acute and chronic health problems. Large doses are used in supplements because most of the mineral is not absorbed. Because Eidon Ionic Minerals are highly absorbed into the bloodstream, it is not necessary to be taken in large doses to be effective.\n\nEidon Ionic Minerals are All Natural, Highly Bioavailable, and contain NO sugars, starch, artificial flavors, colors, preservatives, or animal by-products. 100% Vegan, non-GMO, and Gluten-Free. We use the finest ingredients known to us in the formulation of our unique preparations. Out of respect for all life, we do not test - nor have we ever tested - our products on animals.\n\nPlease join us in the journey to health through education and good practices. Together we can create a healthier world! [redacted-phone]",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:44.659Z",
    importedBy: "entity-db-cli",
  },
};
